import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import TicketPrinter from '../pages/Hardware/TicketPrinter';
import CashDrawer from '../pages/Hardware/CashDrawer';
import BarcodeScanner from '../pages/Hardware/BarcodeScanner';
import TestPrinter from '../pages/Hardware/TestPrinter';
import TestCashDrawer from '../pages/Hardware/TestCashDrawer';
import ProtectedRouteV2 from './ProtectedRouteV2';


const hardwareRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/hardware/printers"
      element={
        <>
          <PageTitle title="Tiquetera | POS System" />
          <TicketPrinter />
        </>
      }
    />
    <Route
      path="/hardware/cash-drawers"
      element={
        <>
          <PageTitle title="Cajón de Dinero | POS System" />
          <CashDrawer />
        </>
      }
    />
    <Route
      path="/hardware/barcode-scanner"
      element={
        <>
          <PageTitle title="Escáner de Código de Barras | POS System" />
          <BarcodeScanner />
        </>
      }
    />
    <Route
      path="/hardware/test-printer"
      element={
        <>
          <PageTitle title="Prueba de Impresora | POS System" />
          <TestPrinter />
        </>
      }
    />
    <Route
      path="/hardware/test-cash-drawer"
      element={
        <>
          <PageTitle title="Prueba de Cajón de Dinero | POS System" />
          <TestCashDrawer />
        </>
      }
    />
  </Route>
);

export default hardwareRoutes;
